import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'suvo-bi-skeleton-grid',
  templateUrl: './skeleton-grid.component.html',
  styleUrls: ['./skeleton-grid.component.scss'],
})
export class SkeletonGridComponent {
  skeletonLayout = [['a', 'a'], ['a'], ['a', 'a']];
}
